let isInFullscreen = false;

const _createStdEvent = (eventName, element) => {
  if (element) {
    try {
      element.dispatchEvent(new Event(eventName));
    } catch {
      // ignore
    }
  }
};

const _proxyFullscreenEvents = (event) => {
  if (event && event.type) {
    const newType = event.type.replace(/^(webkit|moz|MS)/, '').toLowerCase();
    _createStdEvent(newType, document);
  }
};

export function initFullscreen(container, rmpVast, playerWidth, playerHeight) {
  document.addEventListener('webkitfullscreenchange', _proxyFullscreenEvents);
  document.addEventListener('mozfullscreenchange', _proxyFullscreenEvents);
  document.addEventListener('MSFullscreenChange', _proxyFullscreenEvents);

  const onFullscreenChange = () => {
    if (!isInFullscreen) {
      isInFullscreen = true;
      container.classList.add('rmp-fullscreen-on');
      if (rmpVast?.resizeAd) {
        rmpVast.resizeAd(window.screen.width, window.screen.height, 'fullscreen');
      }
    } else {
      isInFullscreen = false;
      container.classList.remove('rmp-fullscreen-on');
      if (rmpVast?.resizeAd) {
        rmpVast.resizeAd(playerWidth, playerHeight, 'normal');
      }
    }
  };

  document.addEventListener('fullscreenchange', onFullscreenChange);

  return {
    toggle() {
      if (isInFullscreen) {
        exitFullscreen(rmpVast);
      } else {
        requestFullscreen(container, rmpVast);
      }
    },
    get isFullscreen() {
      return isInFullscreen;
    },
    destroy() {
      document.removeEventListener('fullscreenchange', onFullscreenChange);
    }
  };
}

function requestFullscreen(container, rmpVast) {
  const video = rmpVast?.adOnStage && rmpVast?.adLinear
    ? rmpVast.adPlayer
    : rmpVast?.contentPlayer;

  if (container.requestFullscreen) {
    container.requestFullscreen();
  } else if (container.webkitRequestFullscreen) {
    container.webkitRequestFullscreen();
  } else if (video?.webkitEnterFullscreen) {
    video.webkitEnterFullscreen();
  }
}

function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}
